import React from 'react';
import {Col, Container, Row} from "react-bootstrap";
import {Link} from 'gatsby';
import Img01 from "../../images/services/ls/Cost-Optimization.webp";
import Img02 from "../../images/services/ls/Minimum-Viable-Product.webp";
import Img03 from "../../images/services/ls/Iterative-Development.webp";
import Img04 from "../../images/services/ls/Resource-Efficiency.webp";
import {LazyLoadImage} from "react-lazy-load-image-component";

function Servicespartner(props) {
    return (
        <div className="tekrevol_gray_bg p-100">
            <Container className="h-100">
                <Row className="h-100">
                    <Col xs={12} md={6} lg={5} xl={5} xxl={5} className="my-auto">
                        <div className="example" data-text="Assisting ">
                            <h2>Assisting You With Sustainable Product Development</h2>
                            <h5
                            className="strong">Why should you choose TekRevol as your lean startup plane partner?</h5>

                        </div>

                        <p>With multiple years of experience working with Fortune 500 companies and other small and medium-sized businesses, we understand the dynamics of developing brands and products necessary to ensure ground-level success. Our digital experts, having developed multiple digital products, know how to build your product and make your lean startup successful</p>
                        <Link to="/contact"
                              className="border_btn" aria-label="TekRevol Contact">Let's Connect!</Link>
                    </Col>
                    <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="mt-lg-5 offset-lg-1">
                        <Row>
                            <Col xs={12} md={6} lg={6} xl={6} xxl={6}>
                                <div className="set_of_images hover01">
                                    <LazyLoadImage
                                        src={Img01}
                                        effect="blur" alt="Image" className="img-fluid"
                                    />
                                    <p className="img_title">Cost Optimization</p>
                                </div>
                                <div className="set_of_images hover01 mt-4">
                                    <LazyLoadImage
                                        src={Img03}
                                        effect="blur" alt="Image" className="img-fluid"
                                    />
                                    <p className="img_title">Iterative Development</p>
                                </div>
                            </Col>
                            <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="mt-lg-4 mt-md-0">
                                <div className="set_of_images hover01">
                                    <LazyLoadImage
                                        src={Img02}
                                        effect="blur" alt="Image" className="img-fluid"
                                    />
                                    <p className="img_title">Minimum Viable Product</p>
                                </div>
                                <div className="set_of_images hover01  mt-4">
                                    <LazyLoadImage
                                        src={Img04}
                                        effect="blur" alt="Image" className="img-fluid"
                                    />
                                    <p className="img_title">Resource Efficiency</p>
                                </div>
                            </Col>
                        </Row>
                    </Col>

                </Row>
            </Container>
        </div>
    );
}

export default Servicespartner;